module.exports = __webpack_public_path__ + "static/media/roleUserTemp.ad03c1ea.xlsx";